import * as React from 'react'
import type {SVGProps} from 'react'
const SvgUpArrow = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" {...props}>
        <path
            fill="#FFF"
            fillRule="evenodd"
            d="m4.313 15.112 7.424-7.424.006.006.005-.006 7.425 7.424-1.06 1.06-6.37-6.368-6.37 6.369-1.06-1.06z"
        />
    </svg>
)
export default SvgUpArrow
